import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { uniqueId } from 'lodash';
import { useMemo } from 'react';

export type PageSize = 25 | 50 | 100 | 500;
type Props = {
    selectedPageSize: PageSize;
    setSelectedPageSize(pageSize: PageSize): void;
};

export const PageSizeSelector = ({ selectedPageSize, setSelectedPageSize }: Props) => {
    const labelId = useMemo(() => uniqueId('pageSize-'), []);

    return (
        <FormControl fullWidth sx={{ width: 80 }}>
            <InputLabel id={labelId}>Page size</InputLabel>
            <Select
                size="small"
                labelId={labelId}
                onChange={e => setSelectedPageSize(e.target.value as PageSize)}
                value={selectedPageSize}
                fullWidth
            >
                {[25, 50, 100, 500].map(pageSize => (
                    <MenuItem key={pageSize} value={pageSize}>
                        {pageSize}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
